module.exports = __webpack_public_path__ + "static/media/4k-logo-reversed.027e6cfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4k-logo-reversed.svg
// module id = 1901
// module chunks = 0